import { Injectable } from '@angular/core';
import { PromoCodeSearchParams } from '@fantaz/shared/data-access/models';
import { select, Store } from '@ngrx/store';

import * as PromoCodeActions from './promo-code.actions';
import * as PromoCodeSelectors from './promo-code.selectors';

@Injectable()
export class PromoCodeFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(PromoCodeSelectors.getPromoCodeLoaded));
  total$ = this.store.pipe(select(PromoCodeSelectors.getTotalPromoCodes));
  loading$ = this.store.pipe(select(PromoCodeSelectors.getPromoCodeLoading));
  error$ = this.store.pipe(select(PromoCodeSelectors.getPromoCodeError));
  allPromoCode$ = this.store.pipe(select(PromoCodeSelectors.getAllPromoCode));
  selectedPromoCode$ = this.store.pipe(select(PromoCodeSelectors.getSelected));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  loadPromoteCodes(
    options: PromoCodeSearchParams = {
      pageIndex: 0,
      pageSize: 5,
    },
  ) {
    this.store.dispatch(PromoCodeActions.loadPromoteCodes({ params: options }));
  }
  loadFromLocalStorage() {
    this.store.dispatch(PromoCodeActions.loadFromLocalStorage());
  }
  confirmPromoCode(promoCode: string, reload?: boolean) {
    this.store.dispatch(
      PromoCodeActions.confirmPromoCode({ promoCodeId: promoCode, reload }),
    );
  }
}
